import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getAllPonds = createAsyncThunk(
  "Ponds/getAllPonds",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/leads/ponds?pageNumber=${
          data.pageNumber || 1
        }&pageSize=${data.pageSize || 20}&sortBy=${
          data?.sortBy || ""
        }&sortOrder=${data?.sortOrder || "desc"}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
